import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BidBaseInfo } from '../interface/make-bid.interface';

@Component({
  selector: 'app-bid-form',
  templateUrl: './bid-form.component.html',
  styleUrls: ['./bid-form.component.scss']
})
export class BidFormComponent implements OnInit {
  @Input() makeBidEditStatus: boolean;
  @Input() editBudgetEstimatesStatus: boolean;
  @Input() reviewResultIsReject: boolean;
  @Input() formid: string;
  @Input() formContent = [];
  @Input() bidBaseInfor: BidBaseInfo;// 厂商的基本信息和备注信息
  @Output() projectNameChanged = new EventEmitter<string>();
  @Output() formChanged = new EventEmitter<Object>();

  formData: FormGroup;
  formLeftData = {};
  formMiddleData = {};
  formRightData = {};
  customerArr = ['纬创资通（中山）有限公司', '纬联电子科技有限公司', '宏碁电脑（中山）有限公司'];
  customerNameOption = [];


  async ngOnInit(): Promise<void> {
    this.formLeftData = this.formContent.slice(0, 7);
    this.formMiddleData = this.formContent.slice(7, 14);
    this.formRightData = this.formContent.slice(14, 15);
    this.customerArr.forEach(ele => {
      this.customerNameOption.push({ label: ele, value: ele });
    });
  }

  // change customerName || projectName
  ngFormChange(value: string, key: string) {
    this.formChanged.emit({ "key": key, "value": value });
  }
}
